import {
  faCaretDown,
  faCaretUp,
  faCheckCircle
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { NAVITEMS } from './Nav.constants';
import {
  StyledNav,
  StyledNavContainer,
  StyledNavLogo,
  StyledNavMobileMenu,
  StyledNavTrigger
} from './Nav.styled';
import NavItem from './NavItem';

const TENav: React.FC = () => {
  const { t } = useI18n('talent-engine-landing-v3');
  const { asPath, locale } = useRouter();
  const navItems = NAVITEMS(t, asPath, locale);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = (): void => setMobileMenuOpen(false);
  return (
    <>
      <StyledNav className="mobile">
        <StyledNavContainer>
          <StyledNavTrigger onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <StyledNavLogo
              src={getPublicPath('/images/talentEngine/talent-engine-logo.svg')}
              alt="Talent Engine"
              width="100"
              height="16"
            />
            <FontAwesomeIcon icon={mobileMenuOpen ? faCaretUp : faCaretDown} />
          </StyledNavTrigger>
          <ScrollLink to="talentEngineForm" href="#talentEngineForm">
            <ButtonLink variant="brandTalent" sizes="xs" as="div">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('talent-engine-landing.features.cta.cta')}</span>
            </ButtonLink>
          </ScrollLink>
        </StyledNavContainer>
        <StyledNavMobileMenu className={mobileMenuOpen ? 'active' : ''}>
          <NavItem
            label={t('talent-engine-landing.nav.start')}
            href={getAppUrl(APP_URLS.talentEngineLanding, locale)}
            isActive={
              asPath === getAppUrl(APP_URLS.talentEngineLanding, locale)
            }
            closeMobileMenu={closeMobileMenu}
          ></NavItem>
          {navItems.map((item, index) => (
            <NavItem
              key={index}
              label={item.label}
              href={item.href}
              options={item.options}
              isActive={item.isActive}
              closeMobileMenu={closeMobileMenu}
              serviceEvent={item.serviceEvent}
            ></NavItem>
          ))}
        </StyledNavMobileMenu>
      </StyledNav>
      <StyledNav className="desktop">
        <StyledNavContainer>
          {navItems.map((item, index) => (
            <NavItem
              key={index}
              label={item.label}
              href={item.href}
              options={item.options}
              isActive={item.isActive}
              serviceEvent={item.serviceEvent}
            ></NavItem>
          ))}
          <ButtonLink
            href={getAppUrl(APP_URLS.companies, locale)}
            variant="brandTalent"
            sizes="sm"
            onClick={() =>
              ServiceEventTracking.trackLandingCtaClicked(
                'talent-engine-quiero-menu'
              )
            }
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>{t('talent-engine-landing.features.cta.cta')}</span>
          </ButtonLink>
        </StyledNavContainer>
      </StyledNav>
    </>
  );
};

export default TENav;
